(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evoavo-editorial-product-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('evoavo-editorial-tabs')) return;
  class EvoavoEditorialTabs extends HTMLElement {
    connectedCallback() {
      if (this.evConnected) return;
      this.evConnected = true;
      this.abort = new AbortController();
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.positions = new WeakMap();
      const on = (node, type, fn, options = {}) => node.addEventListener(type, fn, {...options, signal:this.abort.signal});
      on(this, 'click', e => {
        if (this.suppressClick) { e.preventDefault(); e.stopPropagation(); this.suppressClick = false; return; }
        const tab = e.target.closest('[data-tab]');
        if (tab) this.activate(tab.dataset.tab);
        const swatch = e.target.closest('[data-swatch]');
        if (swatch && !swatch.disabled) this.selectVariant(swatch);
        const nav = e.target.closest('.ev-navigation');
        if (!nav) return;
        const track = nav.closest('[data-panel]').querySelector('.ev-track');
        const points = this.positions.get(track) || [0];
        const index = this.nearest(track, points);
        const dot = e.target.closest('[data-page]');
        if (dot) this.go(track, points[Number(dot.dataset.page)]);
        if (e.target.closest('[data-prev]')) this.go(track, points[Math.max(0,index - 1)]);
        if (e.target.closest('[data-next]')) this.go(track, points[Math.min(points.length - 1,index + 1)]);
      });
      on(this, 'keydown', e => {
        const tab = e.target.closest('[data-tab]');
        if (tab && ['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) {
          e.preventDefault();
          let index = this.tabs.indexOf(tab);
          if (e.key === 'Home') index = 0;
          else if (e.key === 'End') index = this.tabs.length - 1;
          else index = (index + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.activate(this.tabs[index].dataset.tab);
          this.tabs[index].focus({preventScroll:true});
          this.tabs[index].scrollIntoView({block:'nearest',inline:'nearest'});
        }
        if (e.target.matches('.ev-track') && ['ArrowLeft','ArrowRight','Home','End'].includes(e.key) && this.dataset.carousel === 'true') {
          e.preventDefault(); const track = e.target; const points = this.positions.get(track) || [0]; const index = this.nearest(track,points);
          this.go(track,e.key === 'Home' ? 0 : e.key === 'End' ? points[points.length-1] : points[Math.max(0,Math.min(points.length-1,index+(e.key==='ArrowRight'?1:-1)))]);
        }
      });
      on(document, 'shopify:block:select', e => {
        if (this.panels.some(panel => panel.dataset.panel === e.detail.blockId)) this.activate(e.detail.blockId);
      });
      on(document,'visibilitychange',()=>this.syncVideos());
      this.querySelectorAll('.ev-track').forEach(track => {
        on(track, 'scroll', () => this.updateNavigation(track), {passive:true});
        on(track, 'dragstart', e => {if(this.dataset.carousel === 'true') e.preventDefault();});
        let drag = null;
        on(track, 'pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0 || this.dataset.carousel !== 'true' || e.target.closest('button')) return;
          drag = {x:e.clientX,left:track.scrollLeft,id:e.pointerId,moved:false};
        });
        on(track, 'pointermove', e => {
          if (!drag) return;
          const delta=e.clientX-drag.x;
          if (Math.abs(delta)>6) {
            if (!drag.moved) track.setPointerCapture(drag.id);
            drag.moved=true; track.classList.add('ev-dragging'); track.scrollLeft=drag.left-delta;
          }
        });
        const endDrag = () => {
          if (!drag) return;
          if (drag.moved) {
            this.suppressClick=true;
            clearTimeout(this.clickTimer); this.clickTimer=setTimeout(()=>{this.suppressClick=false;},0);
          }
          if(track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
          track.classList.remove('ev-dragging'); drag=null;
        };
        on(track,'pointerup',endDrag); on(track,'pointercancel',endDrag);
        on(track,'pointerleave',()=>{if(drag && !drag.moved) drag=null;});
      });
      this.resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame=requestAnimationFrame(()=>this.refresh());
      });
      this.resizeObserver.observe(this);
      this.videoObserver = new IntersectionObserver(entries => {
        this.inView=entries.some(entry=>entry.isIntersecting); this.syncVideos();
      },{threshold:0.05});
      this.videoObserver.observe(this);
      this.activate(this.dataset.first);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resizeObserver?.disconnect(); this.videoObserver?.disconnect();
      cancelAnimationFrame(this.resizeFrame); cancelAnimationFrame(this.activateFrame); clearTimeout(this.clickTimer);
      this.querySelectorAll('video').forEach(video=>video.pause()); this.evConnected=false;
    }
    activate(id) {
      const panel=this.panels.find(item=>item.dataset.panel===id);
      if(!panel) return;
      this.tabs.forEach(tab=>{const active=tab.dataset.tab===id;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});
      this.panels.forEach(item=>{item.hidden=item!==panel;});
      this.activePanel=panel;
      const track=panel.querySelector('.ev-track');
      if(track) track.scrollTo({left:0,behavior:'instant'});
      this.syncVideos();
      cancelAnimationFrame(this.activateFrame); this.activateFrame=requestAnimationFrame(()=>this.refresh());
    }
    syncVideos() {
      const autoplay=this.dataset.autoplay==='true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && this.inView && !document.hidden;
      this.panels.forEach(panel=>panel.querySelectorAll('video').forEach(video=>{
        if(panel.hidden || !this.inView || document.hidden) video.pause();
        else if(autoplay) {video.muted=true;video.play()?.catch(()=>{});}
      }));
    }
    refresh() {
      const track=this.activePanel?.querySelector('.ev-track'); if(!track) return;
      const nav=this.activePanel.querySelector('.ev-navigation');
      const max=Math.max(0,track.scrollWidth-track.clientWidth);
      const enabled=this.dataset.carousel==='true' && max>2;
      const hasControls=!!nav.querySelector('.ev-dots,[data-next]');
      nav.hidden=!enabled || !hasControls;
      const points=[0];
      if(enabled) {
        const cards=[...track.querySelectorAll('.ev-card')];
        const perView=parseFloat(getComputedStyle(track.parentElement).getPropertyValue('--ev-count')) || 1;
        const step=Math.max(1,Math.floor(perView));
        const first=cards[0]?.getBoundingClientRect().left || 0;
        for(let i=step;i<cards.length;i+=step) {
          const point=Math.min(max,cards[i].getBoundingClientRect().left-first);
          if(point>points[points.length-1]+2) points.push(point);
          if(point>=max-2) break;
        }
        if(max>points[points.length-1]+2) points.push(max);
      }
      this.positions.set(track,points);
      const dots=nav.querySelector('.ev-dots');
      if(dots && dots.childElementCount!==points.length) {
        dots.replaceChildren(...points.map((_,i)=>{const button=document.createElement('button');button.type='button';button.className='ev-dot';button.dataset.page=String(i);button.setAttribute('aria-label',`Go to product page ${i+1}`);button.setAttribute('aria-controls',track.id);return button;}));
      }
      this.updateNavigation(track);
    }
    nearest(track,points) {let best=0;points.forEach((point,i)=>{if(Math.abs(point-track.scrollLeft)<Math.abs(points[best]-track.scrollLeft)) best=i;});return best;}
    updateNavigation(track) {
      const points=this.positions.get(track); if(!points) return;
      const index=this.nearest(track,points);const nav=track.closest('[data-panel]').querySelector('.ev-navigation');
      nav.querySelectorAll('[data-page]').forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
      const prev=nav.querySelector('[data-prev]'),next=nav.querySelector('[data-next]');
      if(prev) prev.disabled=track.scrollLeft<=2;
      if(next) next.disabled=track.scrollLeft>=points[points.length-1]-2;
      const status=nav.querySelector('[data-page-status]');
      const message=`Page ${index+1} of ${points.length}`;if(status.textContent!==message) status.textContent=message;
    }
    go(track,left) {track.scrollTo({left:left || 0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    selectVariant(button) {
      const card=button.closest('[data-product-card]');
      card.querySelectorAll('[data-swatch]').forEach(swatch=>swatch.setAttribute('aria-pressed',String(swatch===button)));
      card.querySelectorAll('[data-product-link]').forEach(link=>{link.href=button.dataset.url;});
      card.dataset.variantId=button.dataset.variantId;
      const price=card.querySelector('[data-price]');
      if(price) price.replaceChildren(button.querySelector('[data-variant-price]').content.cloneNode(true));
      if(button.dataset.image) {
        let img=card.querySelector('.ev-main-image');
        if(!img) {img=document.createElement('img');img.className='ev-main-image';img.sizes='(min-width:1200px) 22vw, (min-width:768px) 30vw, 75vw';card.querySelector('.ev-main-placeholder')?.remove();card.querySelector('.ev-media').prepend(img);}
        img.srcset=button.dataset.srcset;img.src=button.dataset.image;img.alt=button.dataset.alt;img.width=Number(button.dataset.width);img.height=Number(button.dataset.height);
      }
      card.classList.add('ev-variant-selected');
    }
  }
  customElements.define('evoavo-editorial-tabs',EvoavoEditorialTabs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evoavo-review-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('evoavo-review-carousel')) {
    class EvoavoReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-er-track]');
        this.previous = this.querySelector('[data-er-prev]');
        this.next = this.querySelector('[data-er-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.handlePrev = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.update = () => this.updateButtons();
        this.handleBlockSelect = (event) => {
          const item = event.target && event.target.closest('[data-er-item]');
          if (!item || !this.contains(item)) return;
          this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        };
        this.previous.addEventListener('click', this.handlePrev);
        this.next.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.updateButtons();
      }
      disconnectedCallback() {
        this.previous?.removeEventListener('click', this.handlePrev);
        this.next?.removeEventListener('click', this.handleNext);
        this.track?.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
      move(direction) {
        const card = this.track.querySelector('[data-er-item]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 18;
        const delta = card.getBoundingClientRect().width + gap;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * delta, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      updateButtons() {
        if (!this.track) return;
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
      }
    }
    customElements.define('evoavo-review-carousel', EvoavoReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
